/*
 * @Date: 2024-09-29 10:39:08
 * @LastEditTime: 2024-09-30 16:10:57
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import clickOutside from 'v-click-out';
// import "element-ui/lib/theme-chalk/index.css";
import '../theme/index.css';
import element from './element/index';
import App from './App';
import router from './router';
import './permission';
import store from '@/store';
import jsCookie from 'js-cookie';
import Vuex from 'vuex';
import '@/styles/global.scss';
import VueClipBoard from 'vue-clipboard2';
import moment from 'moment';
// 导出文件按钮组件
import exportFileBtn from '@/components/exportFileBtn/exportFileBtn.vue';
import './directives'; // 全局挂载自定义指令
import "./util/popupConfig"
// import infiniteScroll from 'vue-infinite-scroll'
// 引入字体图标
import '@/assets/appIconfont/iconfont.css';
// 引入配置
import './peruser.js';
Vue.use(clickOutside);
Vue.use(element);
Vue.use(router);
Vue.use(Vuex);
Vue.use(VueClipBoard);

Vue.config.productionTip = false;
Vue.prototype.$cookie = jsCookie;
Vue.prototype.$moment = moment;

Vue.component('exportFileBtn', exportFileBtn);

// bus总线 vue实例
Vue.prototype.$bus = new Vue()

const APP_ENV = import.meta.env.VITE_APP_ENV; //当前环境
console.log(APP_ENV, 'APP_ENV 当前环境');

const PROD_ENV = ['pre', 'prod'];
// import Vconsole from 'vconsole';

if (PROD_ENV.indexOf(import.meta.env.VITE_APP_ENV) === -1) {
	// let vConsole = new Vconsole()
	// Vue.use(vConsole)
}

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
